import React from 'react';
import { TFunction, useTranslation } from 'react-i18next';

import SearchDropdown from '../form-fields/formik/SearchDropdown';
import { request } from '../../utils/api';
import { Account } from 'types/account';

type Props = {
  objectPath: string;
  labelId: 'account' | 'fieldServiceAccount';
};

export function EditEvseControllerAccount({ objectPath, labelId }: Props) {
  const { t } = useTranslation();

  return (
    <div style={{ marginBottom: '10px', width: '60%' }}>
      <SearchDropdown
        name={objectPath}
        label={label(t, labelId)}
        onDataNeeded={async ({ name }) => {
          const response = await request({
            path: '/1/accounts/search',
            method: 'POST',
            body: { name },
          });

          return {
            data: response.data.map((account: Account) => ({
              id: account.id,
              name: account.name,
              label: account.name,
              value: account.id,
            })),
          };
        }}
        placeholder={t(
          'editEvseControllersModal.selectOption',
          'Select Option'
        )}
      />
    </div>
  );
}

const label = (t: TFunction, labelId: 'account' | 'fieldServiceAccount') => {
  switch (labelId) {
    case 'account':
      return t('editEvseControllerAccount.accountLabel', 'Account');
    case 'fieldServiceAccount':
      return t(
        'editEvseControllerAccount.fieldServiceAccountLabel',
        'Field Service Account'
      );
  }
};
